const withWorkingHours = workingHours => prevProjectOrTemplate => ({
    ...prevProjectOrTemplate,
    workingHours,
});

export default withWorkingHours;
